import { useEffect } from 'react'
import getModalBody from '../utils/getModalBody'
import DeleteModalProps from '../types/DeleteModalProps'

interface useInitProps extends DeleteModalProps {
  setModalBody: Function
  setModalLoaded: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    if (props.deleteEntryId !== false) {
      props.setModalLoaded(false)
      getModalBody(props).then((bodyElement) => {
        props.setModalBody(bodyElement)
        props.setModalLoaded(true)
      })
    }
  }, [props.deleteEntryId])
}

export default useInit
